<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{$t("modal.spot_programming.spot_copy.title")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>
      
      <div class="component-modal__row">
        <label for="program">{{$t("modal.spot_programming.spot_copy.station")}}
          <small v-if="submitted && model.stations.length == 0" class="pill-required">* {{ $t("modal.common.required") }}</small>
          <small v-else>*</small>
        </label>
        <div class="component-modal__row">
          <template v-for="station in listStations" :key="station.id">
            <div class="component-modal-checkbox" v-if="station.id != props.stationId">
              <label :for="station.id">
                <input type="checkbox" :name="station.id" :id="station.id" :value="station.id" v-model="model.stations">
                {{ station.name }}
              </label>
            </div>
          </template>              
        </div>
      </div>

      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{$t("modal.copy")}}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{$t("modal.cancel")}}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';

export default {
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    const props = computed(() => store.getters.modal_getProps);
    const submitted = ref(false);
    const model = ref({
      stations: [],
    })

    onMounted(async () => {
      console.log(props.value);
      await store.dispatch('station_getAll');
      listStations.value.forEach(station => {
        if (station.id != props.value.stationId) model.value.stations.push(Number(station.id));
      });
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      store.dispatch('loading_setActive', true);

      try {
        await store.dispatch('spots_spotCopy', {...model.value, spotId: props.value.id});
        this.closeModal();
        store.dispatch('loading_setActive', false);
      } catch (error) {
        console.error(error);
      }
    }

    function updateStations(event) {
      const index = model.value.stations.indexOf(Number(event.target.value));
      if (index === -1){
        model.value.stations.push(Number(event.target.value));
      } else {
        model.value.stations.splice(index, 1);
      }
    }

    return {
      v$,
      listStations,
      model,
      submitted,
      saveAndClose,
      closeModal,
      updateStations,
      props
    }
  }
};
</script>